import styles from "../../_styles/InfoBlock.module.scss";

import desctopStyle from "./Desctop.module.scss";
import { firstSectionInfo } from "../../../../constants/structure";
import InfoBlockIcons from "../rightData/InfoBlockIcons";
import useInterfaceContext from "../../../../components/providers/interface";
import { useTranslation } from "react-i18next";
import { setLoginModal } from "../../../../store/slices/modals.slice";
import { useDispatch } from "react-redux";

interface IProps {
  extraClass?: string;
  likeHandler: (e: any, item: any, selectedFlag: boolean) => void;
  favouritesHandler: (e: any, item: any, selectedFlag: boolean) => void;
  inFavourites: boolean;
  liked: boolean;
  shared: boolean;
  updateFieldLocal: (field: string, type: string) => void;
  item: any;
  shareHandler: () => void;
}

const FirstSectionInfoBlock = ({
  extraClass,
  likeHandler,
  favouritesHandler,
  updateFieldLocal,
  liked,
  shared,
  inFavourites,
  shareHandler,
  item,
}: IProps) => {
  const { isMobile } = useInterfaceContext();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const valueHandler = (path: string, def: any, text: string | undefined) => {
    if (path === "likesDetails") {
      return item?.vote_count;
    }
    if (path === "savedDetails") {
      return <div style={{ fontWeight: "bold" }}>{t("save")}</div>;
    }
    if (path === "shareDetails") {
      return item?.shares_count;
    }

    return def;
  };

  const data = firstSectionInfo;

  return (
    <div className={desctopStyle.infoIconsWrapper}>
      {data.map((infoBlockItem: any, index: number) => {
        return (
          <div
            id={infoBlockItem.path}
            key={infoBlockItem.path}
            onClick={(e: any) => {
              const token = localStorage.getItem("accessToken");

              if (infoBlockItem.handler === "like") {
                if (!token) {
                  dispatch(setLoginModal(true));
                  return;
                }

                updateFieldLocal("vote_count", liked ? "decrement" : "increment");
                return likeHandler(e, item, liked);
              }

              if (infoBlockItem.handler === "saved") {
                if (!token) {
                  dispatch(setLoginModal(true));
                  return;
                }

                updateFieldLocal("favorites_count", inFavourites ? "decrement" : "increment");
                return favouritesHandler(e, item, inFavourites);
              }

              if (infoBlockItem.handler === "share") {
                return shareHandler();
              }
            }}
            style={infoBlockItem.path === "savedDetails" ? { fontSize: "12px" } : {}}
            className={`${styles.infoBarItemWrapper} ${extraClass}`}
          >
            <InfoBlockIcons
              isMobile={isMobile}
              iconName={infoBlockItem.path}
              inFavourites={inFavourites}
              shared={shared}
              liked={liked}
            />
            <div>{valueHandler(infoBlockItem.path, infoBlockItem.number, infoBlockItem.additionalText)}</div>
          </div>
        );
      })}
    </div>
  );
};

export default FirstSectionInfoBlock;
